<template>
    <center>
        <div class="imgcontainer">
            <img id="bgimg" :src="imgdat.imgsrc" border="0" @click="toggleDetails" />
            <div id="title" class="top-center"><h1>{{imgdat.imgtitle}}</h1></div>
            <div id="desc" class="bottom-center textColor" v-html="imgdat.imgdesc"></div>
        </div>
    </center>
</template>

<script>
import { ajaxGet,ajaxPost } from "../../../ajax";
import {apiUrl} from "@/main";

export default {
    data: function() {
        return {
            imgdat: {},
            imageId: undefined
        };
    },
    created() {
      this.imageId = this.$router.history.current.params.imageId;
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            if(this.imageId == 'undefined') alert("Not part of assignment.");
            ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.imageId,
        (dat) => {
          //on success dat is called
          if(dat.component == "image"){
            //This is the right component
            this.imgdat = dat.data;
            this.isAnswered = dat.answers;
            window.document.title = dat.title
              //----------------------------------------------------------
              if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                ajaxPost(apiUrl() +"/assignments/" + this.imageId, {
                Data: {
                  seen: Date.now()
                }
              },
              (suc) => {
                console.log("Posted assignment:", suc);
              },
              (err) => {
                console.log("Error :", err)
              }, localStorage.token);
              }
              //----------------------------------------------------------
          }else{
            //Wrong component type
            console.error("DATA MISMATCH on api call expected 'IMAGE' object, got '" + dat.component.toUpperCase() + "' object.");
          }
        },(err) => {
          //There was some error
          console.log(err);
        }, localStorage.token);
    },
    methods: {
      toggleDetails(){
        var title = document.querySelector(".imgcontainer #title");
        var desc = document.querySelector(".imgcontainer #desc");
        if(title.style.display === "none"){
          title.style.display = "block";
          desc.style.display = "block";
        }else{
          title.style.display = "none";
          desc.style.display = "none";
        }
      }
    }
}
</script>

<style scoped>

.imgcontainer {
    position: relative;
    width: 100vw;
    height: 100vh;
    padding-top: 56px;
}
.imgcontainer img {
  background: #121212;
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.top-center {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  max-width:800px;
  width:800px;
  background-color: rgba(0,0,0,0.65);
  color: rgba(255,255,255,255);
  padding: 10px;
  font-size: 24px;
}

.bottom-center {
  color: white !important;
  position: absolute;
  /*bottom: 0px;*/
  left: 50%;
  transform: translate(-50%, 0);
  max-width:1500px;
  width:1000px;
  background-color: rgba(0,0,0,0.35);
  padding: 10px;
}

.textColor{
  color: white !important;
}
</style>